import { PAGE_TYPE } from "@/meta/common";
import { RouteRecordRaw } from "vue-router";

export const storeProjectRouter: RouteRecordRaw[] = [
    {
        path: "/storeProject",
        name: "StoreProjectManagement",
        component: () => import("@/views/layouts/index.vue"),
        meta: {
            title: "项目管理"
        },
        redirect: "/storeProject/index",
        children: [
            {
                path: "index",
                name: "StoreProject",
                component: () => import("@/views/pages/warehouseManagement/storeProject/index.vue"),
                meta: {
                    title: "项目管理",
                    pageType: PAGE_TYPE.LIST.code,
                    hidden: true,
                    activeMenu: "StoreProjectManagement",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_W_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_W_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        },
                        {
                            label: "完结",
                            value: "ROLE_W_PROJECT_BUY_MANAGE"
                        }
                    ]
                }
            },
            {
                path: "add",
                name: "StoreProjectAdd",
                component: () => import("@/views/pages/warehouseManagement/storeProject/add/index.vue"),
                meta: {
                    title: "新增项目",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    isNotShowHeader: true,
                    activeMenu: "StoreProjectManagement",
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "edit/:id",
                name: "StoreProjectEdit",
                component: () => import("@/views/pages/warehouseManagement/storeProject/add/index.vue"),
                meta: {
                    title: "修改项目",
                    pageType: PAGE_TYPE.CACHE_FORM.code,
                    hidden: true,
                    activeMenu: "StoreProjectManagement",
                    isNotShowHeader: true,
                    authOptions: [
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        }
                    ]
                }
            },
            {
                path: "detail/:id",
                name: "StoreProjectInfo",
                component: () => import("@/views/pages/warehouseManagement/storeProject/info/index.vue"),
                meta: {
                    title: "项目详情",
                    pageType: PAGE_TYPE.LOG.code,
                    hidden: true,
                    activeMenu: "StoreProjectManagement",
                    authOptions: [
                        {
                            label: "查看",
                            value: "ROLE_W_PROJECT_R"
                        },
                        {
                            label: "查看所有",
                            value: "ROLE_W_PROJECT_ALL_R"
                        },
                        {
                            label: "处理",
                            value: "ROLE_W_PROJECT_DEAL"
                        },
                        {
                            label: "完结",
                            value: "ROLE_W_PROJECT_BUY_MANAGE"
                        }
                    ],
                    isNotShowHeader: true
                }
            }
        ]
    }
];
